import { Box, Flex, Icon, HStack, Text, Divider } from '@chakra-ui/react';
import guestInfoImage from '../images/guest-info.jpg';
import { GiAmpleDress } from 'react-icons/gi';
import { GiTie } from 'react-icons/gi';
import { IoMdBowtie } from 'react-icons/io';

const GuestInformation: React.FC = () => {
  return (
    <Box
      alignContent="center"
      textAlign="center"
      color="white"
      bgColor="#f2ebe2"
    >
      <Flex
        alignItems="center"
        w="100vw"
        h="90vh"
        bg={`url(${guestInfoImage})`}
        bgSize="cover"
        bgPos="center"
        pos="relative"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgColor="#1f2535"
          mixBlendMode={'multiply'}
          opacity="0.5"
        ></Box>
        <Text fontSize="40px" zIndex={10} w="full" textAlign="center" px={4}>
          GUEST INFORMATION
        </Text>
      </Flex>
      <Box px={10} color="#000000">
        <Box mt={12} mb={12}>
          <Text fontSize="2xl">DRESS CODE</Text>
          <Text fontSize="sm" fontStyle="italic" mt={2} mb={2} px={4}>
            Formal / Semi Formal
            <br />
            <br />
            Gentlemen: Suit and tie (necktie is optional), Long sleeve collared
            shirt
            <br />
            <br />
            Ladies: ankle or knee-length gown or dress, blouse and slacks
            <br />
            <br />
            Reserve white for the Bride and Groom
            <HStack w="full" justifyContent="center" mt={4}>
              <Icon as={GiAmpleDress} color="#3d5280" w="14" h="14" />
              <Icon as={GiTie} color="#6c81c0" w="14" h="14" />
              <Icon as={GiAmpleDress} color="#84a5e3" w="14" h="14" />
              <Icon as={GiTie} color="#8b83c6" w="14" h="14" />
              <Icon as={GiAmpleDress} color="#b5a5d7" w="14" h="14" />
            </HStack>
          </Text>
        </Box>

        <Divider />

        <Box mt={12} mb={12}>
          <Text fontSize="2xl">WEDDING REGISTRY</Text>
          <Text fontSize="sm" fontStyle="italic" mt={2} mb={2} px={4}>
            Having you with us on our special day means more than words can
            express. Your love, support, and presence are truly the greatest
            gifts we could ever receive. Should you wish to bless us with an
            additional gift, a monetary contribution would be deeply appreciated
            as we build our future together.
          </Text>
        </Box>
        <Divider />

        <Box mt={12} mb={12}>
          <Text fontSize="2xl">REMINDERS</Text>
          <Text fontSize="sm" fontStyle="italic" mt={2} mb={2} px={4}>
            Unplugged ceremony
            <br />
            Adults-onnly party
            <br />
            Be on time
            <br />
            Have fun!
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default GuestInformation;
